import CheckboxSkeleton from '../../../../components/FormControls/Checkbox/Skeleton';

const MultipleChoiceQuestionOptionSkeleon = () => {
  return <CheckboxSkeleton />;
};

export default MultipleChoiceQuestionOptionSkeleon;
